import {
    AddIcon,
    Button,
    ChevronDownIcon,
    EditIcon,
    ErrorIcon,
    EyeFriendlierIcon,
    Flex,
    Image,
    PaperclipIcon,
    SendIcon,
    TaskListIcon,
    Text,
    Tooltip,
} from "@fluentui/react-northstar";
import React, { useState } from "react";
import styled from "styled-components";
import Card from "./Card";
import EmptyTodoTask from "../img/EmptyTodoTask.png";
import {
    ACTIONS_DOCUMENTS,
    BADGE_ACTION_DOCUMENTS,
    TASK_ACTIONS,
    TASK_STATUS,
} from "../../../constants/tasks";
import DialogDetailTask from "../../../pages/DashboardTasks/DialogDetailTask";
import Toast from "../../../components/Alerts";
import { useQueryClient } from "react-query";
import { DEVICE } from "../../../constants/responsive";
import { useNavigate } from "react-router-dom";
import {
    DocumentBulletListClock24Filled,
    CheckmarkStarburst20Filled,
} from "@fluentui/react-icons";

const DocumentToUpload = ({
    state,
    setstate,
    todo,
    isLoading,
    isFetching,
    lengthTodo,
}) => {
    const [configToast, setConfigToast] = useState({
        visible: false,
        content: "",
        level: "warning",
    });

    return (
        <ToUploadFlex column>
            <HeaderToDo fill vAlign="center" space="between">
                <Toast
                    level={configToast.level}
                    content={configToast.content}
                    visible={configToast.visible}
                    onStatusChange={() =>
                        setConfigToast({
                            visible: false,
                            content: "",
                            level: "warning",
                        })
                    }
                />
                <LeftHeaderTodo vAlign="center">
                    <SFlexIcon>
                        <PaperclipIcon />
                    </SFlexIcon>
                    <HeaderTextTodo content="Documents & pièces justificatives" />
                </LeftHeaderTodo>
                <RightHeader vAlign="center">
                    <Badge vAlign="center" hAlign="center">
                        {todo?.length}
                    </Badge>
                    <Button
                        iconOnly
                        inverted
                        size="small"
                        styles={{
                            background: "rgba(255, 255, 255, 0.15)",
                        }}
                        onClick={() => setstate(!state)}
                        icon={
                            state ? (
                                <ChevronDownIcon
                                    outline
                                    style={{
                                        color: "white",
                                        width: "20px",
                                        cursor: "pointer",
                                    }}
                                    rotate={180}
                                />
                            ) : (
                                <ChevronDownIcon
                                    outline
                                    style={{
                                        color: "white",
                                        width: "20px",
                                        cursor: "pointer",
                                    }}
                                />
                            )
                        }
                    />
                </RightHeader>
            </HeaderToDo>
            {state ? (
                <ContentTodo column>
                    <Flex column hAlign="center" fill>
                        {lengthTodo === 0 ? (
                            <Flex
                                gap="gap.medium"
                                fill
                                vAlign="center"
                                column
                                hAlign="center"
                            >
                                <Image src={EmptyTodoTask} />
                                <Title content="Toutes les actions ont été effectuées" />
                                <DescriptionText content="Vous receverez un mail en cas d'autres actions à faire" />
                            </Flex>
                        ) : (
                            todo?.map((el) => {
                                return (
                                    <Card
                                        el={el}
                                        isPrimary={true}
                                        ButtonIcon={null}
                                        action={
                                            TASK_ACTIONS.find(
                                                (action) =>
                                                    action.id ===
                                                    el?.document_action
                                            )?.element
                                        }
                                        actionText={el?.name}
                                        icon={
                                            <CheckmarkStarburst20Filled
                                                style={{
                                                    color: "green",
                                                }}
                                            />
                                        }
                                        due_date={el?.due_date}
                                        isLoading={isLoading}
                                        isFetching={isFetching}
                                        status={status}
                                    />
                                );
                            })
                        )}
                    </Flex>
                </ContentTodo>
            ) : null}
        </ToUploadFlex>
    );
};

export default DocumentToUpload;
const SFlexIcon = styled(Flex)`
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
`;
const ToUploadFlex = styled(Flex)`
    @media ${DEVICE.mobileS} {
        padding-inline: 12px;
    }
    @media ${DEVICE.mobileL} {
        padding-inline: 0px;
    }
`;

const DescriptionText = styled(Text)`
    color: #242424;
    text-align: center;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    width: 250px;
`;

const Title = styled(Text)`
    color: #000;
    text-align: center;
    width: 250px;

    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
`;

const RightHeader = styled(Flex)`
    gap: 14px;
`;

const ContentTodo = styled(Flex)`
    overflow-y: scroll;
    max-height: 541px;
    height: 100%;
`;
export const HeaderToDo = styled(Flex)`
    background: var(--purple);
    padding: 14px 18px;
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const HeaderTextTodo = styled(Text)`
    font-size: 14px;
    font-weight: 700;
    color: white;
    flex: 1;
`;
const LeftHeaderTodo = styled(Flex)`
    color: white;
    gap: 12px;
`;
const Badge = styled(Flex)`
    height: 24px;
    width: 24px;
    background-color: var(--purple-light);
    border-radius: 100%;
    color: var(--purple);
    font-weight: bold;
`;
